/* eslint-disable @typescript-eslint/camelcase */
import { Pagination } from "@/domain/entities/Pagination";
import { QueryParamsEntities4 } from "./MainApp";
import { getHubData } from "@/app/infrastructures/misc/Cookies";
import { ConvertObjectCamelToSnakeCaseV2 } from '@/app/infrastructures/misc/common-library/ConvertObjectCamelToSnakeCase';

export class HangingOutgoingSummary {
  lastSync = "";

  totalActivities = 0;
  pendingActitivies = 0;
  doneActivities = 0;

  totalUserOps = 0;
  pendingUserOps = 0;
  doneUserOps = 0;

  totalSTI = 0;
  pendingSTI = 0;
  doneSTI = 0;

  totalBAGGING = 0;
  pendingBAGGING = 0;
  doneBAGGING = 0;

  totalSTT = 0;
  pendingSTT = 0;
  doneSTT = 0;

  constructor(fields?: Partial<HangingOutgoingSummary>) {
    Object.assign(this, fields);
  }
}

export class FollowUpOutgoing {
  opsUsername = "";

  constructor(fields?: Partial<FollowUpOutgoing>) {
    Object.assign(this, fields);
  }
}

export class ActivitiesFollowUpOutgoing {
  activityId = 0;
  activityType = "";
  statusFollowUp = "";
  followUp: FollowUpOutgoing = new FollowUpOutgoing();
  username = "";
  createdAt = "";

  constructor(fields?: Partial<ActivitiesFollowUpOutgoing>) {
    Object.assign(this, fields);
  }
}

export class HistoryFollowUpOutgoing {
  date = "";
  activities: ActivitiesFollowUpOutgoing[] = [];

  constructor(fields?: Partial<HistoryFollowUpOutgoing>) {
    Object.assign(this, fields);
  }
}

export class HistoryFollowUpOutgoingEntities {
  pagination = new Pagination(1, 10, 0);
  data: HistoryFollowUpOutgoing[] = [];

  constructor(fields?: Partial<HistoryFollowUpOutgoingEntities>) {
    Object.assign(this, fields);
  }
}

export class HistoryFollowUpOutgoingFilterRequest {
  activityType = "";
  page = 1;
  limit = 10;
  startDate = "";
  endDate = "";

  constructor(fields?: Partial<HistoryFollowUpOutgoingFilterRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities4({
      ...this,
      hub_id: Number(getHubData()?.hubId || 0)
    }).queryString;
  }
}

export class HangingOutgoingRequest {
  days = "";
  existenceStatus = "";
  statusFollowUp = "";
  search = "";

  constructor(fields?: Partial<HangingOutgoingRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities4(ConvertObjectCamelToSnakeCaseV2({
      ...this,
      hub_id: Number(getHubData()?.hubId || "0")
    })).queryString;
  }
}

export class DownloadHangingOutgoing {
  listStt: string[] = [];

  constructor(listStt: string[]) {
    this.listStt = listStt;
  }

  toPayload() {
    return {
      stt_no: this.listStt,
      hub_id: Number(getHubData()?.hubId || "0")
    };
  }
}

export class ConfirmHangingOutgoingRequest {
  activityType = "";
  opsUsername = "";

  constructor(fields?: Partial<ConfirmHangingOutgoingRequest>) {
    Object.assign(this, fields);
  }

  toJSON() {
    return JSON.stringify({
      hub_id: Number(getHubData()?.hubId || "0"),
      activity_type: this.activityType,
      ops_username: this.opsUsername
    });
  }
}

export class HangingBookingPosSummaryDetail {
  label = "";
  total = 0;
  pending = 0;
  done = 0;

  constructor(fields?: Partial<HangingBookingPosSummaryDetail>) {
    Object.assign(this, fields);
  }
}

export class HangingBookingPosSummary {
  lastSync = "";
  activities = new HangingBookingPosSummaryDetail();
  byLabel: HangingBookingPosSummaryDetail[] = [];

  constructor(fields?: Partial<HangingBookingPosSummary>) {
    Object.assign(this, fields);

    if (fields?.activities) {
      this.activities = new HangingBookingPosSummaryDetail(fields?.activities);
    }

    if (fields?.byLabel) {
      this.byLabel = (fields?.byLabel || []).map(
        (item: any) => new HangingBookingPosSummaryDetail(item)
      );
    }
  }
}
